/* eslint-disable indent */
import Dropdown from 'react-bootstrap/Dropdown'
import Badge from 'react-bootstrap/Badge'
import { getTranslation } from '../services/translations'

const NationalTeamSelector = ({
  staffData,
  handleNationalTeamChange,
  lang = 'fi',
}) => {
  const t = key => getTranslation(lang, key)
  const isU21NationalTeam = name =>
    /\bU\s?-?21\b|\bU21\b|\bUnder\s?21\b/i.test(name || '')

  // Näytä vain jos käyttäjällä on staff-tietoja
  if (!staffData || !staffData.staff || staffData.staff.length === 0) {
    return null
  }

  const mjStaff = staffData.staff.filter(
    s => !isU21NationalTeam(s.nationalTeamName)
  )

  if (mjStaff.length === 0) {
    return null
  }

  const activeTeam = mjStaff.find(
    s => s.nationalTeamId === staffData.activeNationalTeam
  )

  return (
    <div style={{ marginBottom: '20px' }}>
      <h5>{t('nationalTeam')}</h5>
      <Dropdown>
        <Dropdown.Toggle variant="secondary" size="sm">
          {(activeTeam && activeTeam.nationalTeamName) ||
            mjStaff[0].nationalTeamName ||
            t('selectCountry')}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {mjStaff.map(s => (
            <Dropdown.Item
              key={s.nationalTeamId}
              active={s.nationalTeamId === staffData.activeNationalTeam}
              onClick={() =>
                handleNationalTeamChange(s.nationalTeamId, s.nationalTeamName)
              }
            >
              {s.nationalTeamName}{' '}
              <Badge bg={s.role === 'HeadScout' ? 'success' : 'secondary'}>
                {s.role}
              </Badge>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}

export default NationalTeamSelector
